import uniqid from 'uniqid';

const Litter = () => {
    return {
        type:"litter",
        zoomIn:true,
        uniqueId:uniqid.time(),
        parents:{},
        children:{}
    }
}
export default Litter;